module.exports = __webpack_public_path__ + "img/assets.da7cf9b1.svg";